import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SETTINGS_INJECTION_TOKENS } from '@tourfold/shared-kernels/settings-registry';
import { ThemeSettingsComponent } from './settings-theme.component';
import { ResourceAccessGuard } from '@tourfold/shared-kernels/resource-access';

export function provideSettingsElementTheme(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SETTINGS_INJECTION_TOKENS,
      useValue: {
        path: 'theme',
        name: 'Theme',
        icon: 'pi pi-palette',
        component: ThemeSettingsComponent,
        order: 3,
        translateName: 'SETTINGS_THEME.TITLE',
        resource_key: 'theme',
        required_action: 'read',
        canActivate: [ResourceAccessGuard],
        category: {
          id: 'other',
          name: 'Other',
          order: 3,
          translateName: 'SETTINGS.CATEGORIES.OTHER',
        },
      },
      multi: true,
    },
  ]);
}
